"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imperfections = exports.Qualities = exports.PreSewnType = exports.ElasticType = exports.KnownOrEstimated = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["By Meter"] = "By Meter";
    SellingUnit["Bundle"] = "Bundle";
    SellingUnit["Pack"] = "Pack";
    SellingUnit["Roll"] = "Roll";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var KnownOrEstimated;
(function (KnownOrEstimated) {
    KnownOrEstimated["Known"] = "Known";
    KnownOrEstimated["Estimated"] = "Estimated";
})(KnownOrEstimated = exports.KnownOrEstimated || (exports.KnownOrEstimated = {}));
var ElasticType;
(function (ElasticType) {
    ElasticType["Braided"] = "Braided";
    ElasticType["Knitted"] = "Knitted";
    ElasticType["Woven"] = "Woven";
    ElasticType["Swim"] = "Swim";
    ElasticType["Lingerie"] = "Lingerie";
    ElasticType["Foldover"] = "Foldover";
    ElasticType["Drawcord"] = "Drawcord";
    ElasticType["Buttonhole"] = "Buttonhole";
    ElasticType["Plush-Back"] = "Plush-Back";
    ElasticType["Ribbed Non-Roll"] = "Ribbed Non-Roll";
    ElasticType["Cord"] = "Cord";
    ElasticType["Clear"] = "Clear";
    ElasticType["Pre-Sewn"] = "Pre-Sewn";
})(ElasticType = exports.ElasticType || (exports.ElasticType = {}));
var PreSewnType;
(function (PreSewnType) {
    PreSewnType["Cuff"] = "Cuff";
    PreSewnType["Collar"] = "Collar";
    PreSewnType["Waistband"] = "Waistband";
})(PreSewnType = exports.PreSewnType || (exports.PreSewnType = {}));
var Qualities;
(function (Qualities) {
    Qualities["Latex Grip"] = "Latex Grip";
    Qualities["Patterned"] = "Patterned";
})(Qualities = exports.Qualities || (exports.Qualities = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Marks"] = "Marks";
    Imperfections["Dusty"] = "Dusty";
    Imperfections["Discoloured"] = "Discoloured";
    Imperfections["Partially Unrolled"] = "Partially Unrolled";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
//# sourceMappingURL=elasticAttributes.js.map